import React from "react";
import { FluentProvider, webLightTheme, Button } from "@fluentui/react-components";

const UnexpectedErrorScene = () => {

  return (
    <FluentProvider theme={webLightTheme}>
      <div style={{ padding: 20, textAlign: "center", lineHeight: 1.6 }}>
        <h1>Oops! Sorry, that wasn't expected to happen.</h1>
        <p>Something went wrong. Please try again later.</p>
      </div>
    </FluentProvider>
  );
};

export default UnexpectedErrorScene;
